/**
 * Extracted from snippets/buybox-video-carousel.liquid (inline <script> at line 139).
 * Config bridge: window.__nsBuyboxVideoCarouselBlocks, keyed by block id. The snippet renders once per
 * product-info block, so the block id and the carousel's DOM id travel as
 * data and this asset boots once per registered block. Moved out of the
 * document so it is cached and no longer parsed inline (INP work on the PDP).
 */

(function () {
  var cfg = window.__nsBuyboxVideoCarouselBlocks = window.__nsBuyboxVideoCarouselBlocks || {};
  function boot(nsBlockId, nsSettings) {
          function videoCarousel() {
            const section = document.querySelector('.product-info__video-carousel');
            const carousel = document.getElementById(`${nsSettings.carouselId}`);
            if (!carousel || !section) return;

            const breakpoint = window.matchMedia('(min-width:700px)');
            const contentContainerEl = section.querySelector('.video-carousel-container');
            const swiperWrapperEl = section.querySelector('[data-swiper-wrapper]');
            const swiperEl = section.querySelector('[data-swiper-container]');
            const carouselControlsEl = section.querySelector('.video-carousel__controls');

            const {
              layoutMobile,
              layoutDesktop,
              itemsPerRowDesktop,
              itemsPerRowMobile,
              videoCount,
              mobileLoop,
              desktopLoop
            } = contentContainerEl.dataset;

            const videoCountNum = parseInt(videoCount);
            const mobileLoopEnabled = mobileLoop === 'true';
            const desktopLoopEnabled = desktopLoop === 'true';
            const mobileSlidesPerView = parseFloat(itemsPerRowMobile);
            const desktopSlidesPerView = parseFloat(itemsPerRowDesktop);

            let videoCarouselSwiper;

            function shouldEnableLoop(slidesPerView, loopSetting) {
              // Loop only works when:
              // 1. Loop is enabled in settings
              // 2. We have at least slidesPerView + 1 videos
              // 3. The slidesPerView is fractional (like 1.2)
              return loopSetting &&
                     videoCountNum > slidesPerView + 1 &&
                     slidesPerView % 1 !== 0;
            }

            function shouldHideNavigation(slidesPerView, loopSetting) {
              // Hide navigation when:
              // 1. Loop is disabled AND
              // 2. Video count is <= slidesPerView for that breakpoint
              return !loopSetting && videoCountNum <= slidesPerView;
            }

            function waitForSwiper(callback) {
              if (typeof Swiper !== 'undefined') {
                callback();
              } else {
                const checkInterval = setInterval(() => {
                  if (typeof Swiper !== 'undefined') {
                    clearInterval(checkInterval);
                    callback();
                  }
                }, 100);
              }
            }

            function initializeSwiper() {
              if (videoCarouselSwiper) return;

              const mobileLoopActive = shouldEnableLoop(mobileSlidesPerView, mobileLoopEnabled);
              const desktopLoopActive = shouldEnableLoop(desktopSlidesPerView, desktopLoopEnabled);

              // Check if we should hide navigation for mobile
              const hideMobileNav = shouldHideNavigation(mobileSlidesPerView, mobileLoopEnabled);

              videoCarouselSwiper = new Swiper(swiperEl, {
                slidesPerView: mobileSlidesPerView,
                spaceBetween: 8,
                speed: 600,
                loop: mobileLoopActive,
                centeredSlides: mobileLoopActive,
                freeMode: false,
                watchSlidesProgress: true,
                breakpoints: {
                  320: {
                    slidesPerView: mobileSlidesPerView,
                    spaceBetween: 8
                  },
                  480: {
                    slidesPerView: mobileSlidesPerView,
                    spaceBetween: 8
                  },
                  640: {
                    slidesPerView: mobileSlidesPerView,
                    spaceBetween: 8
                  },
                  800: {
                    slidesPerView: Math.min(2, desktopSlidesPerView),
                    spaceBetween: 8
                  },
                  1024: {
                    slidesPerView: desktopSlidesPerView,
                    spaceBetween: 8,
                    loop: desktopLoopActive,
                    centeredSlides: desktopLoopActive,
                  }
                },
                navigation: {
                  nextEl: section.querySelector('.video-carousel__nav--next'),
                  prevEl: section.querySelector('.video-carousel__nav--prev'),
                },
                pagination: {
                  el: section.querySelector('.swiper-pagination'),
                  clickable: true,
                  dynamicBullets: false,
                },
                on: {
                  init: function() {
                    // Pause all videos when carousel initializes
                    this.slides.forEach(slide => {
                      const video = slide.querySelector('video');
                      if (video) {
                        video.pause();
                      }
                    });

                    // Initialize pagination
                    this.pagination.render();
                    this.pagination.init();
                    this.pagination.update();

                    // Handle navigation visibility based on current breakpoint
                    updateNavigationVisibility();
                  },
                  slideChange: function() {
                    // Pause all videos when slide changes
                    this.slides.forEach(slide => {
                      const video = slide.querySelector('video');
                      if (video) {
                        video.pause();
                      }
                    });
                  },
                  breakpoint: function(swiper, breakpointParams) {
                    // Update navigation visibility when breakpoint changes
                    updateNavigationVisibility();
                  }
                }
              });

              // Function to update navigation visibility
              function updateNavigationVisibility() {
                const isDesktop = window.matchMedia('(min-width: 700px)').matches;
                const currentSlidesPerView = isDesktop ? desktopSlidesPerView : mobileSlidesPerView;
                const currentLoopSetting = isDesktop ? desktopLoopEnabled : mobileLoopEnabled;

                if (shouldHideNavigation(currentSlidesPerView, currentLoopSetting)) {
                  swiperEl.classList.add('hide-navigation');
                } else {
                  swiperEl.classList.remove('hide-navigation');
                }
              }

              // Initial navigation visibility update
              updateNavigationVisibility();
            }

            function destroySwiper() {
              if (typeof videoCarouselSwiper !== 'undefined') {
                videoCarouselSwiper.destroy(true, true);
                videoCarouselSwiper = undefined;
              }
            }

            function breakpointChecker(breakpoint) {
              if (breakpoint.matches === true) {
                if (layoutDesktop == 'slider') {
                  swiperWrapperEl.style.display = 'flex';
                  swiperWrapperEl.classList.add('swiper-wrapper');
                  if (carouselControlsEl) carouselControlsEl.style.display = '';
                  waitForSwiper(() => {
                    initializeSwiper();
                  });
                  return;
                } else {
                  swiperWrapperEl.style.display = 'grid';
                  swiperWrapperEl.classList.remove('swiper-wrapper');
                  if (carouselControlsEl) carouselControlsEl.style.display = 'none';
                  destroySwiper();
                  return;
                }
              } else if (breakpoint.matches === false) {
                if (layoutMobile == 'slider') {
                  swiperWrapperEl.style.display = 'flex';
                  swiperWrapperEl.classList.add('swiper-wrapper');
                  if (carouselControlsEl) carouselControlsEl.style.display = '';
                  waitForSwiper(() => {
                    initializeSwiper();
                  });
                  return;
                } else {
                  swiperWrapperEl.style.display = 'grid';
                  swiperWrapperEl.classList.remove('swiper-wrapper');
                  if (carouselControlsEl) carouselControlsEl.style.display = 'none';
                  destroySwiper();
                  return;
                }
              }
            }

            breakpointChecker(breakpoint);
            breakpoint.addEventListener("change", () => {
              breakpointChecker(breakpoint);
            });


      if (carousel) {
        // Play button click handler
        carousel.addEventListener('click', function(e) {
          const playButton = e.target.closest('.video-carousel__item button');
          const videoEl = e.target.closest('.video-carousel__item')?.querySelector('video');

          if (playButton && videoEl) {
            // Pause other videos
            carousel.querySelectorAll('video').forEach(v => {
              if (v !== videoEl) v.pause();
            });

            // Hide cover image
            const cover = e.target.closest('.video-carousel__item')?.querySelector('.video-carousel__cover');
            if (cover) cover.classList.add('is-hidden');
              playButton.classList.add('is-hidden');
            // Play video
            videoEl.play();
            console.log('playing');
          }

          // Fallback: click directly on video to toggle play/pause
          const videoClick = e.target.closest('video');
          if (videoClick && !playButton) {
            if (videoClick.paused) {
              carousel.querySelectorAll('video').forEach(v => {
                if (v !== videoClick) v.pause();
              });
             // videoClick.play();
              console.log('playing1');
            } else {
             // console.log('pause');
             // videoClick.pause();
            }
          }
        });

        // Pause video when it ends
        carousel.addEventListener('ended', function(e) {
          if (e.target.tagName === 'VIDEO') {
            console.log('pausing1');
            e.target.pause();
          }
        }, true);
      }

          }

          // Initialize on DOM ready
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', videoCarousel);
          } else {
            videoCarousel();
          }

          // Reinitialize in Shopify theme editor
          if (Shopify.designMode) {
            document.addEventListener("shopify:section:load", () => {
              videoCarousel();
            });
          }
  
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
